import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import authService from 'services/AuthService';

function AuthGuard({ children }) {
  const session = authService.getSessionInfo();

  if (session && session.user_name) {
    if (authService.isTokenValid()) {
      return children;
    }
    return <Redirect to="/login" />;
  }
  return <Redirect to="/login" />;
}

AuthGuard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
  ]),
};

export default AuthGuard;
